<div
  *ngIf="menu | getShouldInflateColumnHeaderForRow: section : colVm : sectionRowViewModels"
  class="section-column"
  [class.section-column-title]="colVm?.columnType === Types.SectionColumnProductInfoType.ProductTitle"
  [class.section-column-review-score]="colVm?.columnType === Types.SectionColumnProductInfoType.GradingResults"
  [class.section-column-review-score-with-logo]="
    colVm?.columnType === Types.SectionColumnProductInfoType.GradingResults && !colVm?.columnConfig?.columnName
  "
  [style.width.%]="colVm?.widthPercentage"
  [hidden]="menu | getShouldHideHeaderContent: section : colVm">
  <ng-content></ng-content>
</div>
